import { Metamodel } from 'app/model/base/model';
import { FileBasedSettings } from './file-based-settings';
import { OrcDataset } from 'app/model/dataset/orc.dataset';
import { DatasetFormatType } from './dataflow-dataset-settings';
import { IViolation } from 'app/model/base/annotation';
import { DataFlowSource } from '../dataflow-source';
import { DataFlowSink } from '../dataflow-sink';
import { validateFilePathOfFileBasedSettings } from './dataset-settings-validation-utils';
import { adfModelTypeMap } from '../../../registries/consts/adf-model-type-map-const';
import { IValidationContext } from 'shell-models-lib';

@Metamodel.model({
    name: adfModelTypeMap.orc.dataflowSettings,
    validator: OrcSettings.validateOrcSettings
})
export class OrcSettings extends FileBasedSettings {
    public compressionType: string = 'none';

    public getDatasetType(): string {
        return Metamodel.modelFor(OrcDataset).name;
    }

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.Orc;
    }

    public getSubFormat(): string {
        return undefined;
    }

    public getIconClass(): string {
        return 'i-20x20-ORC';
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public static async validateOrcSettings(settings: OrcSettings, context: IValidationContext): Promise<IViolation[]> {
        const violations: IViolation[] = [];
        if (settings.transform instanceof DataFlowSource) {
            const source = settings.transform;
            if (source.isInlineDataset && source.datasetSettings && source.datasetSettings.getFormat() === DatasetFormatType.Orc) {
                violations.push(...(await validateFilePathOfFileBasedSettings(settings, false, context)));
            }
        }

        if (settings.transform instanceof DataFlowSink) {
            const sink = settings.transform;
            if (sink.isInlineDataset && sink.datasetSettings && sink.datasetSettings.getFormat() === DatasetFormatType.Orc) {
                violations.push(...(await validateFilePathOfFileBasedSettings(settings, true, context)));
            }
        }

        return violations.length > 0 ? violations : undefined;
    }
}
